import { IGame } from "@grassrootly/api";
import { Div, Label, Loader, Touchable } from "@grassrootly/rn-core";
import { ScrollView } from "react-native";
import GameStatus from "./GameStatus";
import moment from "moment";

export default function MyGamesList({
  loading,
  games,
  onGamePress,
}: {
  loading: boolean;
  games?: IGame[] | null;
  onGamePress: (id: number) => any;
}) {
  return (
    <Div classNames={["flex1"]}>
      {loading ? (
        <Div classNames={["mt-{30}"]}>
          <Loader size="large" isLoading />
        </Div>
      ) : null}
      {!loading && games && !games.length ? (
        <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight", "mt-{30}"]}>
          No games found
        </Label>
      ) : null}
      <ScrollView
        style={{ marginTop: -16, marginBottom: -16 }}
        contentContainerStyle={{ paddingTop: 16, paddingBottom: 16 }}
      >
        {games && games.length
          ? games.map((game: IGame) => (
              <Touchable
                key={game.id}
                classNames={[
                  "bw-{0}",
                  "borderPrimary",
                  "flex1",
                  "br-{16}",
                  "ph-{12}",
                  "pt-{16}",
                  "pb-{16}",
                  "mb-{8}",
                  "bgSecondaryMain",
                ]}
                onPress={() => onGamePress(game.id)}
              >
                <Div classNames={["flexRow", "alignItemsCenter", "justifyContentCenter"]}>
                  <Label classNames={["mr-{5}"]}>Beli</Label>
                  {/* LOGO */}
                  <Div
                    classNames={[
                      "p-{2}",
                      "bgNeutralDarkerDark",
                      "borderPrimary",
                      "bw-{1}",
                      "h-{30}",
                      "w-{30}",
                      "br-{30}",
                      "alignItemsCenter",
                      "justifyContentCenter",
                      "mr-{10}",
                    ]}
                  >
                    <Label type="l2Regular">B</Label>
                  </Div>
                  <Label classNames={["mr-{15}"]} type="l2Bold">
                    {typeof game.host_score === "number" ? game.host_score : ""}
                  </Label>
                  <Label type="l1Bold">-</Label>
                  <Label classNames={["ml-{15}"]} type="l2Bold">
                    {typeof game.visitor_score === "number" ? game.visitor_score : ""}
                  </Label>
                  {/* LOGO */}
                  <Div
                    classNames={[
                      "p-{2}",
                      "borderPrimary",
                      "bgNeutralDarkerDark",
                      "bw-{1}",
                      "h-{30}",
                      "w-{30}",
                      "br-{30}",
                      "alignItemsCenter",
                      "justifyContentCenter",
                      "ml-{10}",
                    ]}
                  >
                    <Label type="l2Regular">M</Label>
                  </Div>
                  <Label classNames={["ml-{5}"]}>Markeri</Label>
                </Div>
                <Div classNames={["alignItemsCenter", "justifyContentCenter", "mt-{10}"]}>
                  <Label type="l3Regular">{moment(game.datetime).format("ddd DD.MM.YYYY HH:mm")}</Label>
                  {game.location ? (
                    <Label type="l3Regular" classNames={["mt-{4}"]}>
                      {game.location}
                    </Label>
                  ) : null}
                  {game.notes ? (
                    <Label type="l4Bold" classNames={["mt-{8}"]}>
                      {game.notes}
                    </Label>
                  ) : null}
                  <GameStatus status={game.status} />
                </Div>
              </Touchable>
            ))
          : null}
      </ScrollView>
    </Div>
  );
}
